module.exports = __webpack_public_path__ + "img/Dantam Hair 46.b2a60ada.jpg";